const state = {
  treeData: [],
  loading: false,
  promiseStatus: ''
}
export default state
